import { windowExtended } from '@map/types';
import { useCurrentLocale } from '@shared/hooks/intl';
import providers, { AuthProvider } from './providers';

const featureFlagMap = {
  facebook: 'facebookSignin',
  google_oauth2: 'googleSignin',
  diia: 'diiaSignin',
};

const useAvailableProviders = () => {
  const locale = useCurrentLocale();
  const providersObject = providers(locale);
  return (Object.keys(providersObject) as AuthProvider[]).filter(
    (provider) =>
      providersObject[provider].available &&
      // this might be called outside of MAP context and miss this property
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      (!windowExtended.project ||
        windowExtended.project.features.includes(featureFlagMap[provider])),
  );
};

export default useAvailableProviders;
